import { useAddToolCalibrationMutation } from "@common/api/tools"
import { Input } from "@common/components/ui/input"
import { todayInputValue } from "@common/lib/date-utils"
import { handleError } from "@common/utils"
import { createFileRoute } from "@tanstack/react-router"
import { useState } from "react"
import useCustomToast from "@/hooks/use-custom-toast"
import {
  ActionCard,
  ActionField,
  useCloseTo,
} from "@/routes/_layout/tools/-components/action-card"

export const Route = createFileRoute(
  "/_layout/tools/$toolId/calibrations/send",
)({
  component: SendForCalibration,
})

function SendForCalibration(): React.ReactElement {
  const { toolId } = Route.useParams()
  const showToast = useCustomToast()
  const mutation = useAddToolCalibrationMutation()
  const [performedBy, setPerformedBy] = useState("")
  const [sentOn, setSentOn] = useState(todayInputValue())
  const [expectedBackOn, setExpectedBackOn] = useState("")
  const close = useCloseTo()

  const send = () =>
    mutation.mutate(
      {
        tool_id: toolId,
        toolCalibrationCreate: {
          kind: "send",
          performed_by: performedBy.trim(),
          sent_on: sentOn,
          expected_back_on: expectedBackOn || null,
        },
      },
      {
        onSuccess: (tool) => {
          showToast("Sent", `${tool.number} is in calibration.`, "success")
          close()
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ActionCard
      title="Send to calibration"
      confirmLabel="Send"
      ready={Boolean(performedBy.trim() && sentOn)}
      pending={mutation.isPending}
      onCancel={close}
      onConfirm={send}
    >
      <ActionField label="Calibration lab">
        {(id) => (
          <Input
            id={id}
            value={performedBy}
            placeholder="Lab or in-house"
            className="bg-background"
            onChange={(event) => setPerformedBy(event.target.value)}
          />
        )}
      </ActionField>
      <div className="grid grid-cols-2 gap-2">
        <ActionField label="Sent on">
          {(id) => (
            <Input
              id={id}
              type="date"
              value={sentOn}
              className="bg-background"
              onChange={(event) => setSentOn(event.target.value)}
            />
          )}
        </ActionField>
        <ActionField label="Expected back">
          {(id) => (
            <Input
              id={id}
              type="date"
              value={expectedBackOn}
              min={sentOn}
              className="bg-background"
              onChange={(event) => setExpectedBackOn(event.target.value)}
            />
          )}
        </ActionField>
      </div>
    </ActionCard>
  )
}
